let base = '';
const Api = {

  wechatAuthorize: `${base}/mobile/wechat/authorize`,
  wechatUserInfo: `${base}/mobile/wechat/userInfo`,
  wechatBindInfo: `${base}/mobile/wechat/bindInfo`,

  doctorList: `${base}/mobile/doctor/list`,
  doctorInfo: `${base}/mobile/doctor`,
  doctorSchedule: `${base}/mobile/doctor`,
  scheduleSlots: `${base}/mobile/doctor/schedule`,

  appointmentCreate: `${base}/mobile/appointment/create`,
  appointmentCancel: `${base}/mobile/appointment/cancel`,
  appointmentList: `${base}/mobile/appointment/list`,
  appointmentInfo: `${base}/mobile/appointment`,

  doctorWechatAuthorize: `${base}/mobile/doctor/wechat/authorize`,
  doctorWechatUserInfo: `${base}/mobile/doctor/wechat/userInfo`,
  doctorBindDoctor: `${base}/mobile/doctor/wechat/bindDoctor`,
  doctorAppointmentList: `${base}/mobile/doctor/appointments`,
  doctorAppointmentCount: `${base}/mobile/doctor/appointmentCount`,
  doctorAppointmentVisit: `${base}/mobile/doctor/appointment/visit`,
}

export default Api



// WEBPACK FOOTER //
// ./src/api/Api.js